import { createFeatureSelector, createSelector } from '@ngrx/store';
import { customStockProtectionFeatureKey, CustomStockProtectionState, CUSTOM_STOCK_PROTECTION_DETAILS, CUSTOM_STOCK_PROTECTION_OVERVIEW } from './custom-stock-protection.reducer';


export const selectCustomStockProtectionState = createFeatureSelector<CustomStockProtectionState>(
    customStockProtectionFeatureKey
  );
  
//******************************************************
  
export const selectStockProtectionOverview = createSelector(
    selectCustomStockProtectionState,
    (state: CustomStockProtectionState) =>
        state[CUSTOM_STOCK_PROTECTION_OVERVIEW].stockProtectionOverview
);

export const loadingStockProtectionOverview = createSelector(
    selectCustomStockProtectionState,
    (state: CustomStockProtectionState) =>
        state[CUSTOM_STOCK_PROTECTION_OVERVIEW].isLoading
);

export const errorStockProtectionOverview = createSelector(
    selectCustomStockProtectionState,
    (state: CustomStockProtectionState) =>
        state[CUSTOM_STOCK_PROTECTION_OVERVIEW].error
);

//******************************************************
  
export const selectStockProtectionDetails = createSelector(
    selectCustomStockProtectionState,
    (state: CustomStockProtectionState) =>
        state[CUSTOM_STOCK_PROTECTION_DETAILS].stockProtectionDetails
);

export const loadingStockProtectionDetails = createSelector(
    selectCustomStockProtectionState,
    (state: CustomStockProtectionState) =>
        state[CUSTOM_STOCK_PROTECTION_DETAILS].isLoading
);

export const errorStockProtectionDetails = createSelector(
    selectCustomStockProtectionState,
    (state: CustomStockProtectionState) =>
        state[CUSTOM_STOCK_PROTECTION_DETAILS].error
);